import { useSelector } from 'react-redux'
import { COMPONENTS } from '../../../../routers/constants'
import { dataTotalAlert } from '../store/slice'
import { ItemCount } from './ItemCount'

export const ListInfo = () => {
  const data = useSelector(dataTotalAlert)
  const { alertNegative, alertUnread } = data

  return (
    <div className="dFlex justifyContentBetween gap1">
      <ItemCount
        title="dashboard.totalAlert.totalAlert"
        count={alertNegative[0]?.total}
        href={`${COMPONENTS.alerts.route}`}
      />
      <ItemCount
        title="dashboard.totalAlert.unreadAlerts"
        count={alertUnread[0]?.value}
        href={`${COMPONENTS.alerts.route}?readStatus=unread`}
      />
      <ItemCount
        title="dashboard.totalAlert.negativeAlerts"
        count={alertNegative[0]?.value}
        href={`${COMPONENTS.alerts.route}?sentiment=negative`}
      />
    </div>
  )
}
